import React, { useState } from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useOutsideClickRef } from "rooks"
import { TopBarButton, SimpleTopBarButton } from "../components/TopBarButton"
import { getRoute } from "../helpers/routing"
import AccountIcon from "./AccountIcon"
import { SimpleLink, TxlLink } from "./TxlLink"
import { requestLogout } from "../state/modules/login"
import TopMenu from "./TopMenu"
import Menu from "./Menu"

const DropdownIcon = ({ className }) => (
  <span className={`dropdown-icon icon-arrow-down-small ${className}`} />
)

const StyledDropdownIcon = styled(DropdownIcon)`
  font-size: 20px;
  position: relative;
  top: 5px;
`

const StyledAccountBarContent = styled(SimpleTopBarButton)`
  padding-left: 5px;
  padding-right: 10px;
  line-height: inherit;
`

const AccountBarMenu = ({ t, language, fullName, hasSubscription, logout }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  function closeMenu() {
    setIsMenuOpen(false)
  }

  const [ref] = useOutsideClickRef(closeMenu)

  return (
    <div ref={ref}>
      <StyledAccountBarContent
        onClick={() => setIsMenuOpen(isMenuOpen => !isMenuOpen)}
      >
        <AccountIcon />
        <span>{fullName}</span>
        <StyledDropdownIcon />
      </StyledAccountBarContent>
      <TopMenu $isOpen={isMenuOpen}>
        <Menu>
          <ul>
            <li>
              <TxlLink to={getRoute("/profile", language)}>
                {t("##.Menu.Profile")}
              </TxlLink>
            </li>
            {hasSubscription && (
              <li>
                <TxlLink to={getRoute("/customisation", language)}>
                  {t("##.Menu.Customisation")}
                </TxlLink>
              </li>
            )}
            <li>
              <TxlLink
                to={getRoute(
                  hasSubscription ? "/subscription" : "/plans",
                  language
                )}
              >
                {t("##.Menu.Subscription")}
              </TxlLink>
            </li>
            <li>
              <SimpleLink onClick={() => logout()}>
                {t("##.Auth.Logout")}
              </SimpleLink>
            </li>
          </ul>
        </Menu>
      </TopMenu>
    </div>
  )
}

const AccountBar = ({
  className,
  isAuthenticated,
  fullName,
  hasSubscription,
  logout,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  return (
    <div className={className}>
      {isAuthenticated && (
        <AccountBarMenu
          t={t}
          language={language}
          fullName={fullName}
          hasSubscription={hasSubscription}
          logout={logout}
        />
      )}
      {!isAuthenticated && (
        <TopBarButton to={getRoute("/login", language)}>
          {t("##.Auth.SignIn")}
        </TopBarButton>
      )}
    </div>
  )
}

const StyledAccountBar = styled(AccountBar)`
  position: absolute;
  right: 70px;

  & ${TopMenu} {
    max-height: 260px;
    width: 200px;
    right: 0;
  }

  ${Menu}::before {
    right: 12px;
    left: auto;
  }
`

const mapStateToProps = state => {
  return {
    isAuthenticated: state.login.isAuthenticated,
    fullName: state.login.userinfo.fullName,
    hasSubscription: state.login.hasSubscription,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(requestLogout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StyledAccountBar)
